<template>
  <div class='font-size-14 color-regular-text'>
    <div>用户：{{ obj.mobileNumber }}, 动态权益：{{ obj.balance }}, 可用资金：{{ obj.available }}
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from "vue";
import { useStore } from 'vuex'
import { http, httpNoLoading } from "../util/http";
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const obj = reactive({
      mobileNumber: '',
      balance: 0,
      available: 0,
      proportion: 0,
      leverage: 0,
    });

    // 页面传来的menuIdx处理
    vueEvent.on('updateBalanceEvent', () => {
      requestData()
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView();
    });

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('updateBalanceEvent')
    })

    // 渲染画面
    const renderView = () => {
      requestData()
    };

    // 后台获取数据
    const requestData = () => {
      httpNoLoading({
        url: `/balance`,
        method: 'post',
      }).then((res) => {
        processData(res);
      });
    };

    // 加工处理数据
    const processData = (res) => {
      obj.mobileNumber = res.data.data[0].mobileNumber;
      obj.balance = res.data.data[0].balance;
      obj.available = res.data.data[0].available;
    };

    return {
      obj,
    };
  },
};
</script>
<style lang="scss" scoped></style>
